module.exports = __webpack_public_path__ + "img/rocket-full.5af1ddaf.png";